module.exports = __webpack_public_path__ + "static/thy-5-121d19169c1df3bb35fd05a14b8e9728.png";